<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>

  <div class="title-text">Service Purchase Orders</div>
  <div class="section">
    <div class="search-filter-container">
      <div class="search-container">
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search on Service PO Number, RFQ Number, Buyer Name and Keywords"
          class="search-input"
        />
        <button class="search-button" (click)="onSearch()">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses">
      <button
        *ngFor="let status of filterStatuses; let i = index"
        class="status-btn"
        [ngClass]="{ active: activeIndex === i }"
        (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}"
      >
        {{ status.name }}
      </button>

      <!-- More Button with Dropdown -->
      <div class="more-dropdown" [class.open]="dropdownOpen">
        <button class="status-btn more-btn" (click)="toggleDropdown()">
          More...
        </button>
        <div class="dropdown-menu" *ngIf="dropdownOpen">
          <button
            *ngFor="let extra of filterStatusesRfqAndQuote; let j = index"
            class="dropdown-item"
            (click)="onStatusSelect(extra.name, filterStatuses.length + j, extra.label); toggleDropdown()"
            matTooltip="{{ extra.label }}"
          >
              {{ extra.name }}
          </button>
        </div>
      </div>

      <!-- PO Type Switcher Dropdown -->
      <div class="rfq-type-dropdown" style="margin-left: auto;">
        <button class="status-btn rfq-type-btn" [ngClass]="{ active: true }" (click)="togglePoTypeDropdown()">
          Service PO <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">arrow_drop_down</mat-icon>
        </button>
        <div class="dropdown-menu rfq-type-menu" *ngIf="poTypeDropdownOpen">
          <button class="dropdown-item" (click)="navigateToPoType('product'); togglePoTypeDropdown()">
            Product PO
          </button>
          <button class="dropdown-item active-item" (click)="togglePoTypeDropdown()">
            Service PO
          </button>
        </div>
      </div>
    </div>

    <div
      class="filter-section"
      style="display: flex; align-items: center"
      *ngIf="this.selectedPO.length > 0"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedPO.length }} of
          {{ this.totalRecords }} POs</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="purchaseOrderOperation('archive')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          matTooltip="Export All"
          matTooltipPosition="below"
          (click)="exportAllPOs()"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
      </div>
      <div>
        <button
          mat-fab
          class="green-button"
          [matMenuTriggerFor]="menu"
          matTooltip="Show more columns"
        >
          <mat-icon style="position: relative; right: -3px"
            >playlist_add</mat-icon
          >
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            *ngFor="let item of items"
            (click)="toggleSelection(item)"
          >
            <mat-checkbox [checked]="item.selected">{{
              item.label
            }}</mat-checkbox>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="active-table-container">
      <ngx-datatable
        style="border-radius: 5px"
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >

        <ngx-datatable-column name="PO Number" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="PO-Number"
              matTooltip="{{ row.purchaseOrderRefNumber }}"
              matTooltipPosition="below"
              (click)="openPOPreview(row)"
              style="cursor: pointer; "
              >{{ row.purchaseOrderRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              >{{ row.rfqRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Quote Number" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="quote-number"
              matTooltip="{{ row.quoteRefNumber }}"
              matTooltipPosition="below"
              style="cursor: pointer;"
              >{{ row.quoteRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- vessel Name -->
        <ngx-datatable-column name="Vessel" [flexGrow]="0.6">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Vessel"
              matTooltip="{{ row.vesselName }}"
              matTooltipPosition="below"
              >{{ row.vesselName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Port Name" [flexGrow]="0.7">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Port Name"
              matTooltip="{{ row.portName }}"
              matTooltipPosition="below"
              >{{ row.portName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Buyer Name" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{ row.buyerCompanyName }}"
                matTooltipPosition="below"
              >{{ row.buyerCompanyName }}</span>
            </ng-template>
          </ngx-datatable-column>

        <!-- Status -->
        <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill"
              matTooltip="{{
                row.purchaseOrderStatusValue === 'Submitted' ? 'Pending' : row.purchaseOrderStatusValue === 'Approved'?'Accepted' : row.purchaseOrderStatusValue
              }}"
              matTooltipPosition="below"
              [ngStyle]="{ color: getStatusColor(row.purchaseOrderStatusValue) }"
            >
              {{ row.purchaseOrderStatusValue === "Submitted" ? "Pending" : row.purchaseOrderStatusValue === 'Approved'?"Accepted" : row.purchaseOrderStatusValue}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Purchase Order Date" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Purchase Order Date"
              matTooltip="{{row.purchaseOrderDate }}"
              matTooltipPosition="below"
            >
              {{ row.purchaseOrderDate | date : "dd/MM/yyyy" }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column *ngIf="this.selectedStatus === 'Pending' || this.selectedStatus === 'ALL'" name="Expected Delivery Date" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Expected Delivery Date"
              matTooltip="{{ row.expectedDeliveryDate}}"
              matTooltipPosition="below"
            >
              {{ row.expectedDeliveryDate | date : "dd/MM/yyyy"}}
            </span>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column
        name="ATT/Contact/Print/Download"
        [resizeable]="true"
        [sortable]="false"
        [flexGrow]="0"
        [minWidth]="220"
        [maxWidth]="250"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="action-buttons-container">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Attachments"
              matTooltipPosition="below"
              (click)="togglePreview(true, row)"
            >
              <mat-icon>attach_file</mat-icon>
            </button>

            <button
              mat-icon-button
              color="primary"
              matTooltip="Buyer Contact Details"
              matTooltipPosition="below"
              (click)="toggleContactPopUp(true, row)"
            >
              <mat-icon>local_phone</mat-icon>
            </button>

            <span
            matTooltip="Print"
            matTooltipPosition="below"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="downloadPO(row.purchaseOrderId, row.purchaseOrderRefNumber)"
            >
              <mat-icon>print</mat-icon>
            </button>
          </span>

          <span
            matTooltip="Download Excel"
            matTooltipPosition="below"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="generatePoExcel(row.purchaseOrderId, row.purchaseOrderRefNumber)"
            >
              <mat-icon>download</mat-icon>
            </button>
          </span>
          </div>
        </ng-template>
      </ngx-datatable-column>

        <ngx-datatable-column *ngIf="this.selectedStatus === 'Rejected'" name="Purchase Order Rejected Date" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Purchase Order Rejected Date"
              matTooltip="{{row.purchaseOrderRejectedDate }}"
              matTooltipPosition="below"
            >
              {{ row.purchaseOrderRejectedDate | date : "dd/MM/yyyy" }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          *ngFor="let column of selectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              *ngIf="isDate(row[column.prop])"
              matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
              matTooltipPosition="below"
            >
              {{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}
            </span>
            <span
              *ngIf="!isDate(row[column.prop])"
              matTooltip="{{ row[column.prop] || '-' }}"
              matTooltipPosition="below"
            >
              {{ row[column.prop] || '-' }}
            </span>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="this.selectedPO.length == this.documentData.length"
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <input
              type="checkbox"
              [checked]="isChecked(row.purchaseOrderId, 'active')"
              (change)="
                selectDeselectPO(
                  $event,
                  row.purchaseOrderId,
                  row.purchaseOrderId,
                  'active'
                )
              "
            />
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>

    <div class="archive-container" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Service Purchase Orders</span>
        </div>

        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">

        <div class="dropdown-container">
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="archivedMenu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #archivedMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of archivedItems"
              (click)="archivedToggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>

        <ngx-datatable
          style="border-radius: 5px"
          #archivedSection
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="archivedLimit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          (page)="onArchivedPageChange($event)"
          (sort)="onArchivedSort($event)"
          [rowClass]="setRowClass"
        >
          <ngx-datatable-column name="PO Number" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="PO-Number"
                matTooltip="{{ row.purchaseOrderRefNumber }}"
                matTooltipPosition="below"
                (click)="openPOPreview(row)"
                style="cursor: pointer;"
                >{{ row.purchaseOrderRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                >{{ row.rfqRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Quote Number" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="quote-number"
                matTooltip="{{ row.quoteRefNumber }}"
                matTooltipPosition="below"
                style="cursor: pointer;"
                >{{ row.quoteRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- vessel Name -->
          <ngx-datatable-column name="Vessel" [flexGrow]="0.6">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Vessel"
                matTooltip="{{ row.vesselName }}"
                matTooltipPosition="below"
                >{{ row.vesselName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Port Name" [flexGrow]="0.7">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Port Name"
                matTooltip="{{ row.portName }}"
                matTooltipPosition="below"
                >{{ row.portName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Buyer Name" [flexGrow]="1">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                  matTooltip="{{ row.buyerCompanyName }}"
                  matTooltipPosition="below"
                >{{ row.buyerCompanyName }}</span>
              </ng-template>
            </ngx-datatable-column>

          <!-- Status -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="0.8">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="status-pill"
                matTooltip="{{
                  row.purchaseOrderStatusValue === 'Submitted' ? 'Pending' : row.purchaseOrderStatusValue === 'Approved'?'Accepted' : row.purchaseOrderStatusValue
                }}"
                matTooltipPosition="below"
                [ngStyle]="{ color: getStatusColor(row.purchaseOrderStatusValue) }"
              >
                {{ row.purchaseOrderStatusValue === 'Submitted' ? 'Pending' : row.purchaseOrderStatusValue === 'Approved'?'Accepted' : row.purchaseOrderStatusValue }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Purchase Order Date" [flexGrow]="0.8">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Purchase Order Date"
                matTooltip="{{row.purchaseOrderDate }}"
                matTooltipPosition="below"
              >
                {{ row.purchaseOrderDate | date : "dd/MM/yyyy" }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column *ngIf="this.selectedStatus === 'Pending' || this.selectedStatus === 'ALL'" name="Expected Delivery Date" [flexGrow]="0.8">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Expected Delivery Date"
                matTooltip="{{ row.expectedDeliveryDate}}"
                matTooltipPosition="below"
              >
                {{ row.expectedDeliveryDate | date : "dd/MM/yyyy"}}
              </span>
            </ng-template>
          </ngx-datatable-column>

        <ngx-datatable-column
            *ngFor="let column of archivedSelectedColumns"
            [name]="column.label"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || '-' }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Restore Action -->
          <ngx-datatable-column name="Action" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                class="popover_delete"
                [mdePopoverTriggerFor]="appPopover"
                mdePopoverTriggerOn="click"
                [mdePopoverBackdropCloseOnClick]="false"
                mat-icon-button
                #popoverTrigger="mdePopoverTrigger"
              >
                <mat-icon
                  matTooltipClass="mat-tooltip-custom"
                  matTooltip="Restore"
                  matTooltipPosition="below"
                  >restore</mat-icon
                >
              </button>

              <mde-popover
                #appPopover="mdePopover"
                [mdePopoverOverlapTrigger]="false"
              >
                <mat-card class="mat-card-popover popover-card">
                  <mat-card-header class="mat-card-header-popover">
                    <mat-card-title class="popover-title"
                      >Are you sure?</mat-card-title
                    >
                  </mat-card-header>
                  <mat-card-actions
                    class="mat-card-action-popover popover-actions"
                  >
                    <button
                      class="mat-action-btn popover_action cancel"
                      mat-raised-button
                      (click)="popoverTrigger.togglePopover()"
                    >
                      Cancel
                    </button>
                    <button
                      class="mat-action-btn popover_action restore"
                      mat-raised-button
                      color="warn"
                      (click)="RestorePo(true, row)"
                    >
                      Restore
                    </button>
                  </mat-card-actions>
                </mat-card>
              </mde-popover>
            </ng-template>
          </ngx-datatable-column>


        </ngx-datatable>
      </ng-container>
    </div>
  </div>
</div>


<app-contact-details
  [showContactPopup]="showContactPopup"
  [contactData]="selectedBuyer"
  (close)="showContactPopup = false">
</app-contact-details>


<app-document-preview
  [previewDocs]="previewDocs"
  [showPopup]="previewSection"
  (close)="previewSection = false">
</app-document-preview>
